import {
  createColumnHelper,
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
  flexRender,
} from "@tanstack/react-table";
import "./User.css";

const columnHelper = createColumnHelper();

const UserTable = ({ users, tableLoading, onEdit, onDelete, page, perPageSize }) => {
  const columns = [
    columnHelper.display({
      id: "no",
      header: "No",
      size: 50,
      cell: ({ row, table }) => {
        const pageIndex = table.options.meta?.page || 1;
        const perPageSize = table.options.meta?.perPageSize || 10;
        const no = row.index + 1 + (pageIndex - 1) * perPageSize;
        return <div className="text-center">{no}</div>;
      },
    }),
    columnHelper.accessor("name", { header: "Nama" }),
    columnHelper.accessor("email", { header: "Email" }),
    columnHelper.accessor("role", {
      header: "Role",
      cell: (info) => (
        <div className="text-center">{info.getValue() || "-"}</div>
      ),
    }),
    columnHelper.display({
      id: "actions",
      header: "Aksi",
      cell: ({ row }) => (
        <div className="btn-action-user d-flex gap-1 justify-content-center flex-md-row flex-column">
          <button
            className="btn btn-sm btn-warning"
            onClick={() => onEdit(row.original)}
          >
            Edit
          </button>
          <button
            className="btn btn-sm btn-danger"
            onClick={() => onDelete(row.original.id)}
          >
            Hapus
          </button>
        </div>
      ),
    }),
  ];

  const table = useReactTable({
    data: users,
    columns,
    meta: {
      page,
      perPageSize
    },
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  return (
    <>
      {tableLoading ? (
        <div className="d-flex justify-content-center align-items-center py-5">
          <div className="spinner-border text-success" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <div className="table-container" style={{ overflowX: "auto" }}>
          <table className="table table-bordered table-striped">
            <thead>
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id}>
                  {headerGroup.headers.map((header) => (
                    <th key={header.id}>
                      {flexRender(
                        header.column.columnDef.header,
                        header.getContext()
                      )}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody>
              {table.getRowModel().rows?.length > 0 ? (
                table.getRowModel().rows.map((row) => (
                  <tr key={row.id}>
                    {row.getVisibleCells().map((cell) => (
                      <td key={cell.id}>
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={columns.length} className="text-center py-3">
                    Tidak ada data
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

export default UserTable;
